var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ApplicationBanner",class:{
    'ApplicationBanner--training': _vm.isTraining,
    'ApplicationBanner--welcome': _vm.isWelcomeView
  }},[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"headline"},[_c('div',{staticClass:"bannerTitle"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]),_c('div',{staticClass:"bgLeftElement"}),_c('div',{staticClass:"bgRightElement"})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }